<template>
  <div>
    <v-sheet :rounded="isSmallerDisplay() ? '' : 'lg'">
      <v-card-actions>
        <GoBackButton :text="$t('message.back')" color="secondary" />
      </v-card-actions>
      <v-card-title class="text-h5">#{{ hashtag }}</v-card-title>
    </v-sheet>
    <div class="mt-2">
      <PostsDisplay v-if="posts && posts.length > 0" :posts="posts" :add-hovers="true"></PostsDisplay>
      <v-sheet v-else-if="!loadingPosts" :rounded="isSmallerDisplay() ? '' : 'lg'" class="pa-4 text-center">
        {{ $t("message.empty_list") }}
      </v-sheet>
      <div v-if="loadingPosts">
        <v-skeleton-loader type="list-item-avatar-three-line"></v-skeleton-loader>
      </div>
      <div v-if="viewMore" class="text-center">
        <v-btn small color="primary" @click="getPosts(true)">{{ $t("message.view_more") }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import PostService from "@/services/PostService";
import PostsDisplay from "@/components/displays/PostsDisplay.vue";
import GoBackButton from "@/components/inputs/GoBackButton.vue";

const PAGE_SIZE = 20;

export default {
  data() {
    return {
      hashtag: this.$route.params.hashtag,
      posts: null,
      pointer: 0,
      loadingPosts: false,
      viewMore: false,
    };
  },
  components: {
    PostsDisplay,
    GoBackButton,
  },
  beforeRouteUpdate(to, from, next) {
    this.hashtag = to.params.hashtag;
    this.getPosts(false);
    next();
  },
  created() {
    this.getPosts(false);
  },
  methods: {
    getPosts(append) {
      this.loadingPosts = true;
      this.viewMore = false;
      if (!append) {
        this.pointer = 0;
        this.posts = [];
      }
      PostService.hashtagPosts(this.hashtag, this.pointer)
        .then((data) => {
          if (data) {
            this.posts = this.posts.concat(data.posts);
            this.pointer = this.pointer + data.count;
            if (data.count >= PAGE_SIZE) this.viewMore = true;
          }
          this.loadingPosts = false;
        })
        .catch(() => {
          this.loadingPosts = false;
        });
    },
  },
};
</script>

<style scoped></style>
